import styled from 'styled-components'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { GREY_BACKGROUND, FONT_BASE_COLOR } from '@CSSVars/colors'

export const _AgentBlockContainer = styled.div`
  background: ${GREY_BACKGROUND};
  border-radius: 10px;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 32px 32px 9px 32px;
  > div {
    width: 100%;
  }
  max-width: 554px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
     max-width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 0;
    width: 100%;
    background: transparent;
    padding: 0;
  }
`

export const _InsightAgentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
     flex-direction: column;
     gap: 20px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
  }


`
export const _TextContainer = styled.div`
  max-width: 50%;
  width: 45%;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    max-width: 100%;
    margin-top: 8px;
    text-align: center;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    text-align: start;
  }
`

export const _Header = styled.div`
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  color: ${FONT_BASE_COLOR};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const _Subtext = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  color: ${FONT_BASE_COLOR};
  margin-top: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 14px;
    line-height: 22px;
    margin-top: 24px;
    margin-bottom: 32px;
  }
`
